<template>
  <div>
    <ul class="nav">
      <li class="nav-item dropdown">
        <div class="small text-muted" style="text-align: right; color:green; padding-top: 15px;">
          Welcome, {{user.name}}
          <br />(
          <strong v-if="user.hausType == 2">manager</strong>
          <strong v-if="user.hausType == 1">owner</strong>
          <strong v-if="user.hausType == 0">internal</strong>
          )
        </div>
      </li>
      <li class="nav-item dropdown">
        <a
          class="nav-link nav-link"
          data-toggle="dropdown"
          href="#"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <strong v-if="!user.avatar == ''">
            <img
              class="img-avatar"
              :src="user.avatar"
              :alt="user.email"
              style="margin:10px; height:35px;"
            />
          </strong>
          <strong v-if="user.avatar == ''">
            <i
              class="icon-user navbar"
              v-if="user.gender == 'male'"
              style="width: 35px; margin: 10px;padding-left: 0px;"
            ></i>
            <i
              class="icon-user-female navbar"
              v-if="user.gender == 'female'"
              style="width: 35px; margin: 10px;padding-left: 0px;"
            ></i>
          </strong>
        </a>
      </li>
      <b-nav-item-dropdown text right class="m-md-2" v-if="user.hausType > 0">
        <!-- <b-dropdown-item> -->
        <b-form id="globalsearch">
          <b-form-input
            type="text"
            v-model="globalSearch"
            placeholder="Search.."
            :state="formLocation"
          ></b-form-input>
        </b-form>
        <!-- </b-dropdown-item> -->
        <div
          style="position:relative; height:400px; overflow-y:scroll;"
          v-if="locations.length > 8"
        >
          <b-dropdown-item @click="selectLocation(i.id)" v-for="i in locations" :key="i.id">
            <i class="nav-icon icon-location-pin"></i>
            {{i.name}}
          </b-dropdown-item>
        </div>
        <div style="position:relative;" v-if="locations.length <= 8">
          <b-dropdown-item @click="selectLocation(i.id)" v-for="i in locations" :key="i.id">
            <i class="nav-icon icon-location-pin"></i>
            {{i.name}}
          </b-dropdown-item>
        </div>
        <b-dropdown-item
          @click="openSettings()"
          v-if="this.$data.showMenu == 'default' && user.hausType == 1"
          style="background-color: orange;"
        >
          <i class="nav-icon icon-plus" style="color:white;"></i> More
        </b-dropdown-item>
        <b-dropdown-item
          @click="closeSettings()"
          v-if="this.$data.showMenu == 'settings' && user.hausType == 1"
          style="background-color: orange;"
        >
          <i class="nav-icon icon-arrow-left-circle" style="color:white;"></i> Back
        </b-dropdown-item>

        <b-dropdown-item
          @click="openSettingsIntern()"
          v-if="this.$data.showMenu == 'default' && user.hausType == 0"
          style="background-color: orange;"
        >
          <i class="nav-icon icon-plus" style="color:white;"></i> Intern
        </b-dropdown-item>
        <b-dropdown-item
          @click="closeSettings()"
          v-if="this.$data.showMenu == 'settings' && user.hausType == 0"
          style="background-color: orange;"
        >
          <i class="nav-icon icon-arrow-left-circle" style="color:white;"></i> Back
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </ul>
  </div>
</template>

<script>
let qs = require("qs");
const constants = require("../shared/constants");
const BASE = constants.NEWPORT_CONST.API_URL;
//const API = BASE + "/api/users/detail";

function postdata(url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      Authorization: data.access_token,
      accessToken: data.accessToken,
      access_token: data.access_token
    },
    method: "POST"
  }).then(res => res.json());
}

// async function getData() {
//   let parameters = {
//     client_id: constants.NEWPORT_CONST.CLIENT_ID,
//     client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
//     access_token: localStorage.getItem("token")
//   };
//   let res = await postdata(API, parameters);
//   return res.user;
// }

async function filterItems(needle, heystack) {
  var query = needle.toLowerCase();
  return heystack.filter(function(item) {
    return (
      item.name.toLowerCase().indexOf(query) >= 0 ||
      item.description.toLowerCase().indexOf(query) >= 0
    );
  });
}

export default {
  name: "nav-header-user",
  data: () => {
    return {
      // user: {},
      showMenu: "default",
      locations: [],
      locationsFull: [],
      globalSearch: ""
    };
  },
  computed: {
    formLocation() {
      var needle = this.$data.globalSearch;
      if (needle.length > 1) {
        filterItems(needle, this.$data.locationsFull).then(dataList => {
          this.$data.locations = dataList;
        });
      } else {
        this.$data.locations = this.$data.locationsFull;
      }
    }
  },
  props: ["user"],
  mounted() {
    this.showMenu = localStorage.getItem("showmenu");
    let signinMethod = localStorage.getItem("signinMethod");

    if (
      signinMethod &&
      (signinMethod === "facebook" || signinMethod === "google")
    ) {
      // do not using avatar from local, just in case user has change profile pic recently at google or facebook
      this.user.avatar = localStorage.getItem("avatar");
      this.user.name = localStorage.getItem("name");
    }

    let localLocationsList = localStorage.getItem("localLocationsList");


    if (localLocationsList === null || localLocationsList === "undefined") {
      constants.gotoLogin("NavHeaderUser")
    } else {
      this.$data.locations = JSON.parse(localLocationsList);
      this.$data.locationsFull = JSON.parse(localLocationsList);

    }

    let localUserDetail = localStorage.getItem("localUserDetail")

    if(localUserDetail == null || localUserDetail == "undefined") {
      constants.gotoLogin()
    } else {
      localUserDetail = JSON.parse(localUserDetail)
      this.$data.user = localUserDetail
    }

    this.$root.$on("locations", locationList => {
      this.locations = locationList;
    });
  },
  methods: {
    selectLocation(locId) {
      localStorage.removeItem("locationDetail");
      //localStorage.removeItem('localListAvailable')
      localStorage.setItem("showmenu", "default");
      this.$data.showMenu = "default";
      localStorage.setItem("locationId", locId);
      let localLockList = localStorage.getItem('localLocksList')
      
      location.href = "/#/Newport/" + locId;
      location.reload();
    },
    openSettings() {
      localStorage.setItem("showmenu", "settings");
      this.$data.showMenu = "settings";
      location.href = "/#/base/locations/";
      location.reload();
    },
    openSettingsIntern() {
      localStorage.setItem("showmenu", "settings");
      this.$data.showMenu = "settings";
      location.href = "/#/base/AssignHausType/";
      location.reload();
    },
    closeSettings() {
      localStorage.setItem("showmenu", "default");
      this.$data.showMenu = "default";
      location.href = "/";
    },
    sortLocation(favLocation, list, origin) {
      let theRest = origin;
      var index = list.findIndex(x => {
        return x.id == favLocation;
      });
      if (index >= 0) {
        let fav = list[index];
        theRest.splice(index, 1);
        list.unshift(fav);
      }
      return theRest;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/base/haus/NavHeaderUser.vue